import React, { useContext } from 'react';
import proptypes from 'prop-types';
import {
  extend,
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { ProductImage } from '@thd-olt-component-react/product-pod';
import { Checkbox, TableCell, TableRow } from '@one-thd/sui-atomic-components';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const { string, func, number, bool } = proptypes;

export const ProductItem = ({
  itemId, storeId, quantity, isSelected, onSelect
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const { data } = useDataModel('product', {
    variables: {
      itemId
    },
    skip: !itemId,
    context: {
      withAuth: true
    }
  });

  const onItemChange = (__) => {
    const storeSkuNumber = data?.product?.identifiers?.storeSkuNumber;
    const omsThdSku = data?.product?.identifiers?.omsThdSku;
    const specialOrderSku = data?.product?.identifiers?.specialOrderSku;
    const sku = storeSkuNumber || omsThdSku || specialOrderSku;
    const basePrice = data?.product?.pricing?.value || 'n/a';
    onSelect(itemId, quantity, basePrice, sku);
  };

  if (!data?.product?.identifiers?.productLabel) return null;

  return (
    <TableRow key={`materials-${itemId}`}>
      <TableCell className="sui-bg-primary sui-text-center sui-py-2">
        <Checkbox data-testid="mini-item-checkbox" checked={isSelected} onChange={onItemChange} />
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-left sui-px-1 sui-py-2">
        <div className="sui-flex sui-gap-2 sui-pointer-events-none">
          <div className="sui-w-12 sui-min-w-12 sui-align-middle">
            <ProductImage itemId={itemId} />
          </div>
          <ProductHeader
            itemId={itemId}
            storeId={storeId}
            brand="inline"
            brandFontSize="sm"
            titleMaxLine={isMobile ? 3 : 2}
            disableShopThisCollection
          />
        </div>
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2">
        {quantity}
      </TableCell>
      <TableCell className="sui-bg-primary sui-text-center sui-px-2 sui-py-2">
        <Price
          itemId={itemId}
          storeId={storeId}
          large={false}
          type="simple"
          hideBadge
          hideWhenZero
          hideBulkPrice
          hideLimitPerOrder
          hideSavingsText
          stackWasPrice
          omitDetails
        />
      </TableCell>
    </TableRow>
  );

};

ProductItem.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  quantity: number.isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired
};

ProductItem.dataModel = extend({
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    dataSources: stringType(),
    identifiers: shapeType({
      productLabel: stringType().isRequired(),
      storeSkuNumber: stringType(),
      omsThdSku: stringType(),
      specialOrderSku: stringType()
    })
  }),
},
ProductHeader,
ProductImage,
Price
);
